<div [formGroup]="searchFormGroup">
  <div class="container py-3">
    <div *ngIf="isIos" class="d-inline-flex align-items-center mb-3 cursor-pointer p-1" routerLink="/">
      <span [inlineSVG]="'assets/img/chevron-left.svg'" class="svg-8 mr-3 d-flex"></span>
      <span>{{'back'|translate}}</span>
    </div>
    <!--     <div class="d-md-flex radio-filters flex-wrap mb-3">
          <div *ngFor="let service of serviceTypes let i = index" class="d-flex align-items-center mb-2 mb-lg-0 mr-4">
            <input class="cursor-pointer" [value]="service.key" formControlName="ServiceTypeId" id="i{{i}}"
              name="ServiceTypeId" type="radio">
            <label class="pl-2 m-0 cursor-pointer" for="i{{i}}">{{service.value}}</label>
          </div>
        </div> -->
    <div class="form-row">
      <div class="mb-lg-0 mb-3 col-lg-4">
        <ng-select [items]="Specialties" [searchable]="false" bindLabel="specialityName" bindValue="id" class=""
                   formControlName="SpecialityId" notFoundText="{{'notFound1'|translate}}"
                   placeholder="{{'specialty'|translate}}">
        </ng-select>
      </div>
      <div class="mb-lg-0 mb-3 col-lg-2">
        <ng-select [items]="clinics" [searchable]="false"
                   bindLabel="name" bindValue="id" class=""
                   formControlName="clinic" notFoundText="{{'notFound1'|translate}}"
                   [placeholder]="'clinic' | translate">
        </ng-select>
      </div>
      <div class="mb-lg-0 mb-3 col-lg-2">
        <ng-select [items]="insuranceProvider"
                   [searchable]="false" bindLabel="value" bindValue="key" class=""
                   formControlName="providerId" notFoundText="{{'notFound1'|translate}}"
                   [placeholder]="'insurance' | translate">
        </ng-select>
      </div>
      <div class="mb-lg-0 mb-3 col-lg-2">
        <input (click)="picker.open()" [matDatepicker]="picker" [max]="maxDate" [min]="minDate" class="standard-input" [ngClass]="{'border border-danger': nothingFound}"
               formControlName="SlotDateFrom" placeholder="{{'date'|translate}}" type="text">
        <mat-datepicker #picker></mat-datepicker>
      </div>
      <div class="col-lg-2">
        <button (click)="searchData()">{{'search'|translate}}</button>
      </div>
    </div>
  </div>
  <div class="border-bottom"></div>
  <div *ngIf="searchResult.length" class="container py-5">
    <h1 class="doctor-count font-weight-bold uppercase" style="margin-bottom: 5px">{{activeSpecialtyName}}</h1>
    <hr *ngIf="searchFormGroup.get('clinic').value" class="my-4"
        style="background: #EDEDEC 0% 0% no-repeat padding-box; opacity: 0.5">
    <mat-chip-list>
      <mat-chip (removed)="removeClinicFilter()" *ngIf="searchFormGroup.get('clinic').value" [removable]="true"
                class="clinic-chip">
        {{getClinicName(searchFormGroup.get('clinic').value)}}
        <mat-icon matChipRemove>clear</mat-icon>
      </mat-chip>
      <mat-chip (removed)="removeInsuranceProvider()" *ngIf="searchFormGroup.get('providerId').value"
                [removable]="true"
                class="clinic-chip">
        {{getProviderName(searchFormGroup.get('providerId').value)}}
        <mat-icon matChipRemove>clear</mat-icon>
      </mat-chip>
    </mat-chip-list>
    <hr class="my-4" style="background: #EDEDEC 0% 0% no-repeat padding-box; opacity: 0.5">
    <div  #scrollTarget class="d-flex align-items-baseline justify-content-between flex-column-sm">
      <h2 class="doctor-count font-weight-bold uppercase">{{'total-found' | translate}} {{totalResultCount}} {{'doctors' | translate}}</h2>
      <!-- <div class="d-flex mb-4 pr-3">

        <div class="d-flex align-items-center radio-filters">
          <div class="d-flex mx-0 mx-lg-1 align-items-center flex-column-sm">
            <div>
              <input [value]="false" class="cursor-pointer" formControlName="onlyForeignDoctors"
                     name="onlyForeignDoctors" type="radio">
              <span class="text ml-2 text-truncate" style="margin-right: 10px">{{'doctors-from-georgia' | translate}}</span>
            </div>
            <div [class.disabled-ng-select-container]="isInsuranceBubble">
              <input [value]="true" class="cursor-pointer" formControlName="onlyForeignDoctors"
                     name="onlyForeignDoctors" type="radio">
              <span class="text ml-2 text-truncate">{{'doctors-from-abroad' | translate}}</span>
            </div>
          </div>
        </div>
      </div> -->
    </div>

    <div class="date-switcher px-3 row no-gutters justify-content-end align-items-center">
      <div class="col-12 col-lg-7">
        <div class="d-flex align-items-center radio-filters service-type">
          <ng-container *ngFor="let service of serviceTypes let i = index let last = last">
            <div (click)="toggle(service.key)"
                 *ngIf="this.searchResult[0]?.isDoctra && searchFormGroup.get('ServiceTypeId').value === service.key"
                 [class.active]="searchFormGroup.get('ServiceTypeId').value === service.key"
                 class="d-flex mx-0 mx-lg-1 align-items-center">
              <input [value]="service.key" class="cursor-pointer" formControlName="ServiceTypeId" id="i{{i+999}}"
                     name="ServiceTypeId" type="radio">
              <label class="d-flex align-items-center pl-0 pl-lg-2 m-0 cursor-pointer font-14 text-truncate"
                     for="i{{i+999}}">
              <span *ngIf="service.key == 3" [inlineSVG]="'assets/img/phone.svg'"
                    class="svg-18 d-block d-lg-none"></span>
                <span *ngIf="service.key == 2" [inlineSVG]="'assets/img/home.svg'"
                      class="svg-18 d-block d-lg-none"></span>
                <span *ngIf="service.key == 1" [inlineSVG]="'assets/img/video.svg'"
                      class="svg-18 d-block d-lg-none"></span>
                <span class="text ml-2 text-truncate">{{service.value}}</span>
              </label>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="col-12 col-lg-5 py-3 py-lg-0 calendar-responsive">
        <div class="day-switcher">
          <button (click)="searchNextDate(false)" [disabled]="checkForBackwardDisable()"
                  [inlineSVG]="'assets/img/long-arrow-left.svg'" class="svg-20"
                  mat-icon-button></button>
          <button (click)="searchNextDate(true)" [disabled]="checkForNextDisable()"
                  [inlineSVG]="'assets/img/long-arrow-right.svg'" class="svg-20"
                  mat-icon-button></button>
        </div>
        <div class="calendar-wrapper-responsive px-lg-5 px-md-4 px-sm-0">
          <div #timeTableWrapper class="time-table__wrapper form-row mx-0 w-100">
            <ng-container *ngFor="let date of searchableDates">
              <div class="px-1 slot-column col-3">
                <div class="time-table-title position-relative">
                  <div class="text-center">
                    <span class="d-block">{{date | date : 'E' : '' : selectedLanguage}}</span>
                    <span class="d-block font-weight-bold mr-1">{{date | date:'MMM, dd' : '' : selectedLanguage}}</span>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
    <ng-container *ngFor="let doctor of searchResult">
      <app-doctor-search-result (navigateToClosestAvailableDate)="navigateToClosestAvailableDate($event)"
                                (onSpecialtyChange)="getDoctorTimeSlotsBySpecialty($event, doctor)"
                                (reinitializeSearchResults)="reinitializeSearch($event)"
                                [doctor]="doctor"
                                [selectedServiceType]="searchFormGroup.get('ServiceTypeId').value"
                                [selectedSpeciality]="specialtyId">
      </app-doctor-search-result>
    </ng-container>
    <button (click)="searchData(true)" *ngIf="totalPageCount -1 > currentPage" class="more"
            matRipple>{{'more'|translate}}</button>
    <div *ngIf="isSpecialtyPage && false" [ngClass]="{more: showFullSpecialtyInfo}" class="specialty-info-wrapper">
      <div #specialtyInfo class="specialty-info">

      </div>
      <div [ngClass]="{more: showFullSpecialtyInfo}" class="show-more__specialty">
        <button (click)="showFullSpecialtyInfo = !showFullSpecialtyInfo" matRipple>
          {{showFullSpecialtyInfo ? ('see-less' | translate) : ('see-more' | translate)}}
        </button>
      </div>
    </div>
  </div>
  <div *ngIf="nothingFound" class="text-center py-5">
<!--    <b>{{'dataNotFound'|translate}}</b> old one-->
    <b>{{'no-free-specialist-was-found-on-this-date.-choose-another-date.' | translate}}</b>
  </div>
</div>
